import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export interface UserInfo {
  id: string
  username: string
  email: string
  avatar?: string
  balance: number
  createdAt: string
}

export const useUserStore = defineStore('user', () => {
  // State
  const token = ref<string>(localStorage.getItem('token') || '')
  const userInfo = ref<UserInfo | null>(null)
  
  // Getters
  const isLoggedIn = computed(() => !!token.value)
  
  // Actions
  const setToken = (newToken: string) => {
    token.value = newToken
    localStorage.setItem('token', newToken)
  }
  
  const setUserInfo = (info: UserInfo) => {
    userInfo.value = info
  }
  
  const logout = () => {
    token.value = ''
    userInfo.value = null
    localStorage.removeItem('token')
  }
  
  // Mock登录
  const login = async (username: string, password: string): Promise<boolean> => {
    // 模拟API调用
    return new Promise((resolve) => {
      setTimeout(() => {
        if (username && password) {
          const mockToken = 'mock_token_' + Date.now()
          setToken(mockToken)
          setUserInfo({
            id: 'user_' + Date.now(),
            username: username,
            email: username + '@example.com',
            balance: 1000,
            createdAt: new Date().toISOString()
          })
          resolve(true)
        } else {
          resolve(false)
        }
      }, 800)
    })
  }
  
  // Mock注册
  const register = async (username: string, email: string, password: string): Promise<boolean> => {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (username && email && password) {
          const mockToken = 'mock_token_' + Date.now()
          setToken(mockToken)
          setUserInfo({
            id: 'user_' + Date.now(),
            username: username,
            email: email,
            balance: 10000, // 新用户赠送10000 tokens
            createdAt: new Date().toISOString()
          })
          resolve(true)
        } else {
          resolve(false)
        }
      }, 800)
    })
  }
  
  return {
    token,
    userInfo,
    isLoggedIn,
    setToken,
    setUserInfo,
    logout,
    login,
    register
  }
})